export const MERCHANT_CATEGORY_CODE = {
    "0001": "TAP (PORTUGAL)",
    "0002": "ANSA INTERNATIONAL",
    "0003": "CARLTON HOTELS",
    "0004": "AIR CARRIERS, AIRLINES NOT ELSEWHERE CLASSIFIED",
    "0005": "TRAVEL AGENCIES AND TOUR OPERATORS",
    "0006": "UTLTS ELCTRC, GAS, HEATING OIL, SANITARY, WATER",
    "0007": "COMPUTERS, COMPUTER PERIPHERAL EQUIPMENT, SOFTWARE",
    "0008": "PRECIOUS STONES AND METALS, WATCHES AND JEWELRY",
    "0009": "MOBILE HOME DEALERS",
    "0010": "DEPARTMENT STORES",
    "0011": "VARIETY STORES",
    "0012": "GROCERY STORES, SUPERMARKETS",
    "0013": "MISC FOOD STORE CONVENIENCE,MRKT,SPLTY,VENDNG MACS",
    "0014": "AUTOMOTIVE PARTS, ACCESSORIES STORES",
    "0015": "MEN'S AND BOY'S CLOTHING AND ACCESSORIES STORES",
    "0016": "WOMEN'S READY TO WEAR STORES",
    "0017": "FAMILY CLOTHING STORES",
    "0018": "SHOE STORES",
    "0019": "MEN'S AND WOMEN'S CLOTHING STORES",
    "0020": "EQUIP, FURNITURE, HOME FURNSHNGS STRS (EXCPT APPL)",
    "0021": "MISCELLANEOUS HOUSE FURNISHING SPECIALTY SHOPS",
    "0022": "ELECTRONIC SALES",
    "0023": "COMPUTER SOFTWARE STORES",
    "0024": "EATING PLACES, RESTAURANTS",
    "0025": "BAR,LOUNGE,DISCO,NIGHTCLUB,TAVERN ALCOHOLIC DRINKS",
    "0026": "SPORTING GOODS STORES",
    "0027": "BOOK STORES",
    "0028": "CLOCK, JEWELRY, WATCH, AND SILVERWARE STORE",
    "0029": "GAME, TOY, AND HOBBY SHOPS",
    "0030": "GIFT, CARD, NOVELTY AND SOUVENIR SHOPS",
    "0031": "DIRECT MARKETING OTHER DIRECT MARKETERS/NOT ELSEW.",
    "0032": "FUEL DEALERS COAL, FUEL OIL, LIQ PETROLEUM, WOOD",
    "0033": "LODGING HOTELS,MOTELS,RESORTS NOT CLASSIFIED",
    "0034": "TIMESHARES",
    "0035": "BARBER AND BEAUTY SHOPS",
    "0036": "OTHER SERVICES (NOT ELSEWHERE CLASSIFIED)",
    "0037": "EQUIPMENT RENTAL&LEASING SVS, FURNTURE/TOOL RENTAL",
    "0038": "BUSINESS SERVICES NOT ELSEWHERE CLASSIFIED",
    "0039": "AUTOMOBILE RENTAL AGENCY NOT ELSEWHERE CLASSIFIED",
    "0040": "AUTOMOTIVE SERVICE SHOPS",
    "0041": "GAMBLING TRANSACTIONS",
    "0042": "CLUBS CNTRY,MBRSHIP(ATHLET,REC,SPRTS,PRIVATE GOLF",
    "0043": "HOSPITALS",
    "0044": "PORTUGAL MONEY TRANSFER",
    "0045": "PORTUGAL QUASI CASH MBR FINANCIAL INSTITUTION",
    "0046": "PORTUGAL QUASI CASH MERCHANT",
    "0047": "PORTUGAL REMOTE STORED VALUE LOAD MBR FIN. INST.",
    "0048": "PORTUGAL REMOTE STORED VALUE LOAD MERCHANT",
    "0049": "PORTUGAL MONEY TRANSFER MBR FIN INSTITUTION",
    "0050": "PORTUGAL TRUCK STOP TRANSACTIONS",
    "0051": "OFFICE, SCHOOL SUPPLY, AND STATIONERY STORES",
    "0052": "DRUG STORES, PHARMACIES",
    "0053": "HEALTH  AND BEAUTY SPAS",
    "0054": "RECORD SHOPS",
    "0055": "HARDWARE STORES",
    "0056": "HOTEL IBIS",
    "0057": "HOTEL MERCURE",
    "0058": "SOFITEL HOTELS",
    "0059": "NOVOTEL HOTELS",
    "0060": "HOUSEHOLD APPLIANCE STORES",
    "0061": "COSMETIC STORES",
    "0062": "EYEGLASSES",
    "0063": "MARINE SERVICE AND SUPPLIES",
    "0064": "SHERATON",
    "0065": "FORTE HOTELS",
    "0066": "PASSENGER RAILWAYS",
    "0067": "TELECOMMUNICATION SERVICES",
    "0068": "ARTIST SUPPLIES AND CRAFT SHOP",
    "0069": "RECREATIONAL FACILITIES",
    "0070": "WESTIN",
    "0072": "TELECOMMUNICATION EQUIPMENT INCL TELEPHONE SALES",
    "0742": "VETERINARY SERVICES",
    "0743": "WINE PRODUCERS",
    "0744": "CHAMPAGNE PRODUCERS",
    "0763": "AGRICULTURAL COOPERATIVES",
    "0780": "LANDSCAPING AND HORTICULTURAL SERVICES",
    "1008": "CONCESSION CATEGORY",
    "1332": "PHONE WAREHOUSE, S.L.",
    "1334": "EUROPA RENT A CAR",
    "1337": "TELEFONICA (FRANCHISES): EQUIPMENT SALES",
    "1339": "MCDONALDS",
    "1340": "MCDONALDS (FRANCHISES)",
    "1342": "AHORRAMAS (FRANCHISES)",
    "1343": "BARCELO HOTELS",
    "1344": "VIAJES BARCELO (FRANCHISES)",
    "1345": "VODAFONE (FRANCHISES): EQUIPMENT SALES",
    "1346": "SARAS ENERGIA",
    "1347": "ALSA RESTAURANTS",
    "1348": "ALSA",
    "1349": "REPSOL RESTAURANTS",
    "1350": "SUPERMERCADOS LUPA",
    "1351": "PRIVALIA",
    "1352": "PRIVALIA VIAJES",
    "1353": "DIA",
    "1354": "DIA (FRANCHISES)",
    "1355": "PRIMARK",
    "1356": "SPORT ZONE",
    "1357": "ZIPPY KIDSTORE",
    "1358": "DESIGUAL",
    "1359": "LOGITRAVEL",
    "1361": "WORTEN",
    "1362": "EROSKI (FRANCHISES)",
    "1363": "ALCAMPO",
    "1364": "ALCAMPO SERVICE",
    "1365": "MARSANS TRAVEL",
    "1366": "CONSUM",
    "1367": "CONSUM SERVICE",
    "1368": "NESPRESSO",
    "1369": "METRO BARCELONA",
    "1370": "ALDI",
    "1371": "BLANCO",
    "1372": "RUMBO TOURS",
    "1373": "FROIZ",
    "1374": "TERMINALA",
    "1375": "IT\u00cdNERE",
    "1378": "AQUALUNA",
    "1379": "HIPER USERA",
    "1380": "METRO DE MADRID",
    "1382": "GAME GROUP",
    "1383": "REDCATS ESPANA",
    "1384": "GENERAL OPTICA",
    "1385": "PEPEMOBILE:MOBILE TOP UP",
    "1386": "CARREFOUR:MOBILE TOP UPS",
    "1387": "ALCAMPO: MOBILE TOP UP",
    "1388": "EROSKI: MOBILE TOP UP",
    "1389": "VIAJES CARREFOUR",
    "1390": "CONDIS (FRANCHISES)",
    "1391": "BODYBELL JUTECO",
    "1392": "GUCCI",
    "1393": "CLICKAIR",
    "1394": "MANGO (FRANCHISES)",
    "1395": "MAS Y MAS SUPERMERCADOS",
    "1396": "CORPORACIxN ALIMENTARIA GUISSONA",
    "1397": "CONDIS SUPERMERCADOS",
    "1398": "PORTUGAL BARCELO HOTELS",
    "1399": "MAKRO RESTAURANTS",
    "1400": "SUPERMERCADOS EL ARBOL",
    "1401": "BON PREU",
    "1402": "MIQUEL ALIMENTACIO",
    "1403": "AHORRAMAS",
    "1404": "TENGELMANN ESPANA",
    "1405": "LIDL",
    "1406": "H&M MODA",
    "1407": "VUELING AIRLINES",
    "1408": "PC CITY",
    "1409": "SUPERMERCADOS GADISA",
    "1410": "LECLERC",
    "1411": "CONSUM",
    "1412": "AUMAR",
    "1413": "MERCADONA",
    "1414": "CAPRABO",
    "1415": "EROSKI",
    "1416": "FORUM SPROT (EROSKI)",
    "1417": "DAPARGEL (EROSKI)",
    "1418": "SUPERMERCADOS SOL/AHOLD",
    "1419": "AIR EUROPA",
    "1420": "CEPSA",
    "1421": "DEPARTMENT STORES OF HOUSEHOLD APPLIANCE",
    "1422": "BRICO STOCK",
    "1423": "GRUPO CARREFOUR",
    "1424": "MEDIA MARKET",
    "1425": "METRO BILBAO",
    "1426": "MO/TO TRAVEL AGENCIES",
    "1427": "MO/TO HOUSEHOLD APPLIANCE AND COMPUTERS",
    "1428": "MO/TO FOOD",
    "1429": "MO/TO BOOKS AND RECORDS",
    "1430": "MO/TO OTHERS",
    "1431": "VEHICLE TECHNICAL INSPECTION",
    "1432": "TERRA MITICA",
    "1433": "GLOBALIA CAR RENTAL",
    "1434": "SUPERMERCADOS UVESCO",
    "1435": "HOUSEHOLD APPLIANCE STORES(URENDE ELECTO)",
    "1436": "FAMILY CLOTHING STORE(KIABI)",
    "1437": "CHARITABLE AND SOCIAL SERVICE ORGANIZATIONS",
    "1438": "HOUSEHOLD APPLIANCE STORES(MENAJE DEL HOGAR)",
    "1439": "PIMKIE",
    "1440": "AUTOMOTIVE PARTS AND ACCESSORIES STORES(TIENDAS AU",
    "1441": "CAMERA AND PHOTOGRAPHIC SUPPLY STORES(FOTOPRIX)",
    "1442": "BAZAR EL REGALO",
    "1443": "CASINO GAMING CHIPS (JESALI)",
    "1444": "DEPARTMENT STORES (UNZU)",
    "1445": "FINANCIAL INSTITUTIONS",
    "1446": "EROSKI BIDAIAK",
    "1447": "PERLAS MANACOR",
    "1448": "TRAVEL AGENCIES AND TOUR OPERATORS  VIAJES IBERIA",
    "1449": "SPORT MEMBERSHIP CLUBS",
    "1450": "FAMILY CLOTHING STORE (LOS TELARES)",
    "1451": "FEUVERT/DELAUTO",
    "1452": "SHOE STORES (ANBAO)",
    "1453": "NON LUCRATIVE ORGANIZATIONS",
    "1454": "ELECTRONIC COMMERCE",
    "1455": "TV RENTAL",
    "1456": "ISLA MAGICA",
    "1457": "BAUHAUS",
    "1458": "HOTEL ARTS",
    "1459": "PROMOD ESPAZA",
    "1460": "PILMA",
    "1461": "ELECTRONIC COMMERCE",
    "1462": "IKEA",
    "1463": "DEPARTMENT STORES OF HOME SUPPLY",
    "1464": "FOOD PROVISIONERS   FREEZER AND LOCKER",
    "1465": "CANDY, NUT AND CONFECTIONARY STORES",
    "1466": "KITCHEN FORNITURES",
    "1467": "ONCE: EQUIPMENT SALES",
    "1468": "FAMILY CLOTHING STORE (ADOLFO DOMPNGUEZ)",
    "1469": "AUTOMOTIVE PARTS AND ACCESSORIES STORES (NORAUTO)",
    "1470": "BOOK AND RECORD STORES (FNAC)",
    "1471": "DEPARTMENT STORES OF FLORISTS",
    "1472": "DEPARTMENT STORES OF COSMETIC AND CLEANING",
    "1473": "DEPARTMENT STORES OF HARDWARE",
    "1474": "ALDEASA",
    "1475": "ESTABLECIMIENTOS MIRO",
    "1476": "HOTELS AND MOTELS (PARADORES NACIONALES)",
    "1477": "COLLEGES, UNIVERSITIES AND PROFESSIONAL SCHOOLS",
    "1478": "TRAVEL AGENCIES AND TOUR OPERATORS R.A.C.C.",
    "1479": "DEPARTMENT STORES (IKEA FRANCHISE)",
    "1480": "DEPARTMENT STORES (LEROY MERLIN)",
    "1481": "TELECOMMUNICATIONS SERVICES. TELEPHONIC TRAFFIC",
    "1482": "VACATION INTERCHANGE",
    "1483": "PORT AVENTURA",
    "1484": "CASINO GAMING CHIPS (CANAMASA)",
    "1485": "TRAVEL AGENCIES AND TOUR OPERATORS   ULTRAMAR EXPR",
    "1486": "CAMERA AND PHOTOGRAPHIC SUPPLY STORES (VISIONLAB)",
    "1487": "DEPARTMENT STORES (BRICO HOGAR)",
    "1488": "FAMILY CLOTHING STORE (MANGO)",
    "1489": "FINANCIAL BIDDINGS",
    "1490": "TAX PAYMENTS TO GOVERNMENT INSTITUTIONS",
    "1491": "GLOBALIA  TRAVEL AGENCIES",
    "1492": "THOMSON TURISMO Y VIAJES S.A.",
    "1493": "DECATHLON",
    "1494": "MARSANS  TRAVEL AGENCIES",
    "1495": "BARCELO  TRAVEL AGENCIES",
    "1496": "GLOBALIA   HOTELS",
    "1497": "TRANSPRTN SVCS. SALES ON BOARD (AIRLINES & RAILRD)",
    "1498": "DEPARTMENT STORES (MARK & SPENCER)",
    "1499": "AIR EUROPA: SALES ON BOARD",
    "1500": "SPANAIR: SALES ON BOARD",
    "1501": "IBERIA: SALES ON BOARD",
    "1502": "ORANGE:MOBILE TOP UP",
    "1503": "MOVISTAR:MOBILE TOP UP",
    "1504": "VODAFONE:MOBILE TOP UP",
    "1520": "GENERAL CONTRACTORS/RESIDENTIAL BUILDINGS",
    "1521": "AGIP",
    "1522": "BP OIL",
    "1524": "ALCAMPO SERVICE STATIONS",
    "1525": "CARREFOUR SERVICE STATIONS",
    "1526": "RETAIL OPERATING COMPANY",
    "1527": "MAKRO SERVICE STATIONS",
    "1528": "LECLERC SERVICE STATIONS",
    "1529": "EROSKI SERVICE STATIONS",
    "1530": "CORP. ALIM. GUISSONA GASOLINERAS",
    "1531": "DISA",
    "1711": "HEATING, PLUMBING, AIR CONDITIONING CONTRACTORS",
    "1731": "ELECTRICAL CONTRACTORS",
    "1740": "INSULATION,MASONRY,PLSTER,STONEWRK,TILESET CNTRCTR",
    "1750": "CARPENTRY CONTRACTORS",
    "1761": "ROOFING AND SIDING, SHEET METAL WORK CONTRACTORS",
    "1771": "CONCRETE WORK CONTRACTORS",
    "1799": "CONTRACTORS,SPECIAL TRADE NOT ELSEWHERE CLASSIFIED",
    "2002": "FAST FOOD",
    "2013": "HOTELS AND MOTELS (C.A.T.)",
    "2014": "NH PARKINGS (C.A.T.)",
    "2097": "SPANAIR (C.A.T.)",
    "2102": "IBERIA (C.A.T.)",
    "2111": "SUBWAY PASSENGER TRANSPORTATION (C.A.T.)",
    "2131": "LOCAL RAILROADS AND INTERCITY BUSES (C.A.T.)",
    "2133": "LOCAL TRANSPORTATION  EXCEPT SUBWAY (C.A.T.)",
    "2215": "MAIL & COURIER SERVICES (C.A.T.)",
    "2231": "PREPAID SERVICES FOR AFFILIATES: GYMS (C.A.T.)",
    "2310": "INSURANCE SALES (C.A.T.)",
    "2340": "MCDONALDS (FRANCHISES C.A.T.)",
    "2346": "SARAS ENERGIA (C.A.T.)",
    "2347": "ALSA (C.A.T.)",
    "2364": "ALCAMPO SERVICE STATIONS (FRANCHISES) (C.A.T.)",
    "2367": "CONSUM SERVICE STATIONS (FRANCHISES) (C.A.T.)",
    "2369": "METRO BARCELONA (C.A.T.)",
    "2380": "METRO DE MADRID (C.A.T.)",
    "2385": "PEPEMOBILE: MOBILE TOP UP (CAT)",
    "2386": "CARREFOUR:MOBILE TOP UP (CAT)",
    "2387": "ALCAMPO: MOBILE TOP UP (CAT)",
    "2388": "EROSKI:MOBILE TOP UP (CAT)",
    "2397": "CONDIS PARKINGS (C.A.T.)",
    "2398": "CHARITABLE AND SOCIAL SERVICE ORGANIZATION (C.A.T.",
    "2399": "POSTAL SERVICE (C.A.T.)",
    "2401": "BON PREU SERVICE STATIONS (C.A.T.)",
    "2411": "MUSEUMS (C.A.T.)",
    "2412": "RAILROADS   RENFE (C.A.T.)",
    "2419": "AIR EUROPA (C.A.T.)",
    "2420": "CEPSA (C.A.T.)",
    "2422": "VENDING MACHINES",
    "2425": "METRO BILBAO (C.A.T.)",
    "2432": "TERRA MITICA (C.A.T.)",
    "2433": "DEPARTMENT STORES (VPA PLUS)",
    "2434": "UVESCO SERVICE STATIONS (C.A.T.)",
    "2437": "CHARITABLE AND SOCIAL SVC ORGANIZATIONS (C.A.T.)",
    "2453": "NON LUCRATIVE ORGANIZATIONS (C.A.T.)",
    "2454": "VIRTUAL CARD RELOADING (C.A.T.)",
    "2456": "ISLA MAGICA (C.A.T.)",
    "2481": "MOBILE TOP UP (CAT)",
    "2483": "PORT AVENTURA (C.A.T.)",
    "2489": "FINANCIAL BIDDINGS (C.A.T.)",
    "2490": "TAX PAYMENTS TO GOVERNMENT INSTITUTIONS (C.A.T.)",
    "2491": "GLOBALIA   TRAVEL AGENCIES (C.A.T.)",
    "2494": "MARSANS   TRAVEL AGENCIES (C.A.T.)",
    "2501": "VODAFONE: TELEPHONE CARDS (C.A.T.)",
    "2502": "ORANGE:MOBILE TOP UP (CAT)",
    "2503": "MOVISTAR: TELEPHONE CARDS (C.A.T.)",
    "2511": "AIRLINES (C.A.T.)",
    "2521": "AGIP (C.A.T.)",
    "2522": "BP OIL (C.A.T.)",
    "2523": "PARKING LOTS AND GARAGES (C.A.T.)",
    "2524": "ALCAMPO SERVICE STATIONS (C.A.T.)",
    "2525": "CARREFOUR SERVICE STATIONS (C.A.T.)",
    "2526": "RETAIL OPERATING COMPANY (C.A.T.)",
    "2527": "MAKRO SERVICE STATIONS (C.A.T.)",
    "2528": "LECLERC SERVICE STATIONS (C.A.T.)",
    "2529": "EROSKI SERVICE STATIONS (C.A.T.)",
    "2530": "CORP. ALIM. GUISSONA SERVICE STATIONS (C.A.T.)",
    "2531": "DISA (C.A.T.)",
    "2541": "AUTOMATED FUEL DISPENSERS",
    "2543": "REPOSOL/CAMPSA (C.A.T.)",
    "2548": "MELIA PARKINGS",
    "2722": "TRAVEL AGENCIES (C.A.T.)",
    "2732": "CABLE AND OTHER PAY TELEVISION SERVICE",
    "2734": "RECORD STORES (C.A.T.)",
    "2741": "MISCELLANEOUS PUBLISHING AND PRINTING",
    "2791": "TYPESETTING, PLATE MAKING & RELATED SERVICES",
    "2842": "SANITATION, POLISHING & SPECIALITY CLEANING PREP",
    "2912": "DRUG STORES  (C.A.T.)",
    "2941": "COMMERCIAL SPORTS AND MISCELLANEOUS ENTERTAINERS (",
    "2942": "BOOK AND RECORD STORES (C.A.T.)",
    "2946": "VIDEO TAPES RENTAL STORES (C.A.T.)",
    "2961": "DIRECT MARKETING (C.A.T.)",
    "2994": "DIRECT MRKTNG CONTINUITY/SUBSRIPTN MRCHTS (C.A.T.)",
    "2995": "GOVERNMENT SERVICES (C.A.T.)",
    "3000": "UNITED AIRLINES",
    "3001": "AMERICAN AIRLINES",
    "3002": "PAN AM",
    "3003": "EUROFLY",
    "3004": "TRANS WORLD AIRLINES",
    "3005": "BRITISH A",
    "3006": "JAPAN AIR LINES",
    "3007": "AIR FRANCE",
    "3008": "LUFTHANSA",
    "3009": "AIR CAN",
    "3010": "ROYAL DUTCH AIRLINES (KLM)",
    "3011": "AEROFLOT",
    "3012": "QANTAS",
    "3013": "ALITALIA",
    "3014": "SAUDI ARABIAN AIRLINES",
    "3015": "SWISS AIR",
    "3016": "SCANDINAVIAN AIRLINE SYSTEM (SAS)",
    "3017": "SOUTH AFRICAN AIRWAYS",
    "3018": "VARIG (BRAZIL)",
    "3019": "GRMNWGAIR",
    "3020": "AIR INDIA",
    "3021": "AIR ALGERIE",
    "3022": "PHILIPPINE AIRLINES",
    "3023": "MEXICANA",
    "3024": "PAKISTAN INTERNATIONAL",
    "3025": "AIR NEW ZEALAND LIMITED INTERNATIONAL",
    "3026": "EMIRATES AIRLINES (ABBR. EMIRATES)",
    "3027": "UNION DE TRANSPORTS AERIENS",
    "3028": "AIR MALTA",
    "3029": "SNBRU AIR",
    "3030": "AEROLINEAS ARGENTINAS",
    "3031": "OLYMPIC AIRWAYS",
    "3032": "EL AL",
    "3033": "ANSETT AIRLINES",
    "3034": "AUSTRALIAN AIRWAYS (TAA)",
    "3035": "TAP (PORTUGAL)",
    "3036": "VASP (BRAZIL)",
    "3037": "EGYPTAIR",
    "3038": "KUWAIT AIRWAYS",
    "3039": "AVIANCA",
    "3040": "GULF AIR (BAHRAIN)",
    "3041": "BALKAN BULGARIAN AIRLINES",
    "3042": "FINNAIR",
    "3043": "AER LINGUS",
    "3044": "AIR LANKA (ABBR. AIR LANKA)",
    "3045": "NIGERIA AIRWAYS",
    "3046": "CRUZERIO DO SUL (BRAZIL)",
    "3047": "THY (TURKEY)",
    "3048": "ROYAL AIR MAROC",
    "3049": "TUNIS AIR",
    "3050": "ICELANDAIR",
    "3051": "AUSTRIAN AIRLINES",
    "3052": "LAN AIR",
    "3053": "AVIACO (SPAIN)",
    "3054": "LADECO (CHILE)",
    "3055": "LAB (BOLIVIA)",
    "3056": "QUEBECAIRE",
    "3057": "EAST WEST AIRLINES (AUSTRALIA)",
    "3058": "DELTA",
    "3059": "DBA AIR",
    "3060": "NORTHWEST",
    "3061": "CONTINENTAL",
    "3062": "HLX",
    "3063": "U.S. AIRWAYS (USAIRWYS)",
    "3064": "ADRIA AIRWAYS (ABBR: ADRIA)",
    "3065": "AIR INTER",
    "3066": "SOUTHWEST AIRLINES",
    "3067": "VANGUARD AIRLINES (ABBR: VANGUARD)",
    "3068": "AIRSTANA",
    "3069": "SUN COUNTRY AIRLINES   SUNCNTRY",
    "3071": "AIR BRITISH COLUMBIA",
    "3072": "CEBU PACIFIC   CEBU PAC",
    "3075": "SINGAPORE AIRLINES",
    "3076": "AEROMEXICO",
    "3077": "THAI AIRWAYS",
    "3078": "CHINA AIRLINES",
    "3079": "JETSTAR AIRWAYS   JETSTAR",
    "3081": "NORDAIR",
    "3082": "KOREAN AIRLINES",
    "3083": "AIR AFRIQ",
    "3084": "EVA AIRWAYS (BR)",
    "3085": "MIDWEST",
    "3086": "CARNIVAL AIRLINES (KW)",
    "3087": "METRO AIRLINES",
    "3088": "CROATIA",
    "3089": "TRANSAERO (ABBR. TRANSAERO)",
    "3090": "UNI AIRWAYS",
    "3092": "MIDWAY AIRLINES",
    "3094": "ZAMBIA AIRWAYS",
    "3095": "WARDAIR (CANADA)",
    "3096": "AIR ZIMBABWE",
    "3097": "SPANAIR",
    "3098": "ASIANA",
    "3099": "CATHAY PACIFIC",
    "3100": "MALAYSIAN AIRLINE SYSTEM",
    "3102": "IBERIA",
    "3103": "GARUDA (INDONESIA)",
    "3106": "BRAATHENS S.A.F.E. (NORWAY)",
    "3110": "WINGS AIRWAYS",
    "3111": "BRITISH MIDLAND",
    "3112": "WINDWARD ISLAND",
    "3115": "TOWER AIR",
    "3117": "VENEZOLANA INTERNATIONAL DE AVIACION (VIASA)",
    "3118": "VALLEY AIRLINES",
    "3125": "TAN AIRLINES",
    "3126": "TALAIR",
    "3127": "TACA INTERNATIONAL",
    "3129": "SURINAM AIRWAYS",
    "3130": "SUNWORLD INTERNATIONAL AIRWAYS",
    "3131": "VLM AIRLINES   VLM",
    "3132": "FRONTIER",
    "3133": "SUNBELT AIRLINES",
    "3135": "SUDAN AIRWAYS",
    "3136": "QATAR AIRWAYS COMPANY W.L.L. (QATAR AIR)",
    "3137": "SINGLETON AIR",
    "3138": "SIMMONS AIRLINES",
    "3143": "SCENIC AIRLINES",
    "3144": "VIRGIN ATLANTIC",
    "3145": "SAN JUAN AIRLINES",
    "3146": "LUXAIR",
    "3148": "AIR LITTORAL S. A.  (LITTORAL)",
    "3151": "AIR ZAIRE",
    "3154": "PRINCEVILLE",
    "3156": "GO FLY LTD.   GOFLY",
    "3159": "PROVINCETOWN BOSTON AIRWAYS (PBA)",
    "3161": "ALL NIPPON AIRWAYS",
    "3164": "NORONTAIR",
    "3165": "NEW YORK HELICOPTER",
    "3167": "AERO CONT",
    "3170": "MOUNT COOK",
    "3171": "CANADIAN AIRLINES",
    "3172": "NATION AIR",
    "3174": "JETBLUE AIRWAYS (JETBLUE)",
    "3175": "MIDDLE EAST AIR",
    "3176": "METROFLIGHT AIRLINES",
    "3177": "AIRTRANS A",
    "3178": "MESA AIR",
    "3180": "WESTJET AIRLINES",
    "3181": "MALEV HUNGARIAN AIRLINES",
    "3182": "LOT   POLISH AIRLINES",
    "3183": "OMAN AIR",
    "3184": "LIAT",
    "3185": "LAV LINEA AEROPOSTAL VENEZOLANA",
    "3186": "LAP LINEAS AEREAS PARAGUAYAS",
    "3187": "LACSA (COSTA RICA)",
    "3188": "VIRGIN EXPRESS",
    "3190": "JUGOSLAV AIR",
    "3191": "ISLAND AIRLINES",
    "3192": "IRAN AIR",
    "3193": "INDIAN AIRLINES",
    "3195": "HOLIDAY AIRLINES",
    "3196": "HAWAIIAN AIR",
    "3197": "HAVASU AIRLINES",
    "3198": "HARBOR AIRLINES",
    "3199": "SERVICIOS AEREOS MILITARES",
    "3200": "GUYANA AIRWAYS",
    "3203": "GOLDEN PACIFIC AIR",
    "3204": "FREEDOM AIRLINES",
    "3206": "CHINAEAST",
    "3211": "NORWEGIAN",
    "3212": "DOMINICANA DE AVIACION",
    "3213": "MALMO AVIATION MALMO AV",
    "3215": "DAN AIR SERVICES",
    "3216": "CUMBERLAND AIRLINES",
    "3217": "CSA CESKOSLOVENSKE AEROLINIE",
    "3218": "CROWN AIR",
    "3219": "COMPANIA PANAMENA DE AVIACION (COPA)",
    "3220": "COMPANIA FAUCETT",
    "3221": "TRANSPORTES AEREOS MILITARES ECUATORIANOS",
    "3222": "COMMAND AIRWAYS",
    "3223": "COMAIR",
    "3226": "SKYWAYS SKYWAYS",
    "3228": "CAYMAN AIRWAYS",
    "3229": "SAETA (SOCIEDAD ECUATORIANAS DE TRANSPORTES AEREO)",
    "3231": "SAHSA (SERVICIO AERO DE HONDURAS)",
    "3233": "CAPITOL AIR",
    "3234": "CARIBBEAN",
    "3235": "BROCKWAY AIR",
    "3236": "AIR ARABIA AIRLINE AIR ARAB",
    "3238": "BEMIDJI AVIATION",
    "3239": "BAR HARBOR AIRLINES",
    "3240": "BAHAMASAIR",
    "3241": "AVIATECA (GUATEMALA)",
    "3242": "AVENSA",
    "3243": "AUSTRIAN AIR SERVICE",
    "3245": "EASYJET",
    "3246": "RYANAIR",
    "3247": "GOL AIRLINES   GOL",
    "3248": "TAM AIRLINES   TAM",
    "3251": "ALOHA AIRLINES",
    "3252": "ALM ANTILEAN AIRLINES",
    "3253": "AMERICA WEST",
    "3254": "US AIR SHUTTLE",
    "3256": "ALASKA AIRLINES INC.",
    "3259": "AMERICAN TRANS AIR    ATA AIR",
    "3260": "SPIRIT AIRLINES SPIRIT",
    "3261": "AIR CHINA",
    "3262": "RENO AIR INC.",
    "3263": "ASERCA",
    "3266": "AIR SEYCHELLES",
    "3267": "AIR PANAMA INTERNATIONAL",
    "3268": "AIR PACIFIC",
    "3275": "AIR NEVADA",
    "3276": "AIR MIDWEST",
    "3277": "AIR MADAGASCAR",
    "3279": "AIR LA",
    "3280": "AIR JAMAICA",
    "3282": "AIR DJIBOUTI",
    "3284": "AERO VIRGIN ISLANDS",
    "3285": "AERO PERU",
    "3286": "AERO.NICARAGUENSES",
    "3287": "AERO COACH AVIATION",
    "3291": "ARIANA AFGHAN",
    "3292": "CYPRUS AIRWAYS",
    "3293": "EQUATORIANA",
    "3294": "ETHIOPIAN AIRLINES",
    "3295": "KENYA AIRWAYS",
    "3296": "AIRBERLIN",
    "3297": "TAROM ROMANIAN AIR TRANSPORT",
    "3298": "AIR MAURITIUS",
    "3299": "WIDEROE'S FLYVESELSKAP",
    "3300": "AZUL BRAZILIAN AIRLINES",
    "3301": "WIZZ AIRLINES",
    "3351": "AFFILIATED AUTO RENTAL",
    "3352": "AMERICAN INTERNATIONAL",
    "3353": "BROOKS RENT A CAR",
    "3354": "ACTION AUTO RENTAL",
    "3355": "SIXT CAR RENTAL",
    "3357": "HERTZ",
    "3359": "PAYLESS CAR RENTAL",
    "3360": "SNAPPY CAR RENTAL",
    "3361": "AIRWAYS RENT A CAR",
    "3362": "ALTRA AUTO RENTAL",
    "3364": "AGENCY RENT A CAR",
    "3366": "BUDGET RENT A CAR",
    "3368": "HOLIDAY RENT A CAR",
    "3370": "RENT A WRECK",
    "3374": "ACCENT RENT A CAR",
    "3376": "AJAX RENT A CAR",
    "3380": "TRIANGLE RENT A CAR",
    "3381": "EUROPCAR",
    "3385": "TROPICAL RENT A CAR",
    "3386": "SHOWCASE RENTAL CARS",
    "3387": "ALAMO RENT A CAR",
    "3388": "MERCHANTS RENT A CAR",
    "3389": "AVIS RENT A CAR",
    "3390": "DOLLAR RENT A CAR",
    "3391": "EUROPE BY CAR",
    "3393": "NATIONAL CAR RENTAL",
    "3394": "KEMWELL GROUP RENT A CAR",
    "3395": "THRIFTY CAR RENTAL",
    "3396": "TILDEN RENT A CAR",
    "3398": "ECONO CAR RENT A CAR",
    "3399": "AMEREX RENT A CAR",
    "3400": "AUTO HOST CAR RENTAL",
    "3405": "ENTERPRISE RENT A CAR",
    "3409": "GENERAL RENT A CAR",
    "3411": "ATLANTA RENT A CAR",
    "3412": "A1 RENT A CAR",
    "3414": "GODFREY NATIONAL RENT A CAR",
    "3419": "ALPHA RENT A CAR",
    "3420": "ANSA INTERNATIONAL",
    "3421": "ALLSTATE RENT A CAR",
    "3423": "AVCAR RENT A CAR",
    "3425": "AUTOMATE RENT A CAR",
    "3427": "AVON RENT A CAR",
    "3428": "CAREY RENT A CAR",
    "3429": "INSURANCE RENT A CAR",
    "3430": "MAJOR RENT  A  CAR",
    "3431": "REPLACEMENT RENT A CAR",
    "3432": "RESERVE RENT A CAR",
    "3433": "UGLY DUCKLING RENT A CAR",
    "3434": "USA RENT A CAR",
    "3435": "VALUE RENT A CAR",
    "3436": "AUTOHANSA RENT A CAR",
    "3437": "CITE RENT A CAR",
    "3438": "INTERENT RENT A CAR",
    "3439": "MILLEVILLE RENT A CAR",
    "3440": "VIA ROUTE RENT A CAR",
    "3441": "ADVANTAGE RENT A CAR",
    "3501": "HOLIDAY INNS",
    "3502": "BEST WESTERN HOTELS",
    "3503": "SHERATON",
    "3504": "HILTON HOTELS",
    "3505": "FORTE HOTELS",
    "3506": "GOLDEN TULIP HOTELS",
    "3507": "FRIENDSHIP INNS",
    "3508": "QUALITY INNS",
    "3509": "MARRIOTT",
    "3510": "DAYS INNS",
    "3511": "ARABELLA HOTELS",
    "3512": "INTERCONTINENTAL HOTELS",
    "3513": "WESTIN",
    "3514": "AMERISUITES",
    "3515": "RODEWAY INNS",
    "3516": "LAQUINTA INNS",
    "3517": "AMERICANA HOTELS",
    "3518": "SOL HOTELS",
    "3519": "PULLMAN INTERNATIONAL HOTELS",
    "3520": "MERIDIEN HOTELS",
    "3521": "ROYAL LAHAINA RESORT",
    "3522": "TOKYO HOTEL",
    "3523": "PENINSULA HOTELS",
    "3524": "WELCOMGROUP HOTELS",
    "3525": "DUNFEY HOTELS",
    "3526": "PRINCE HOTELS",
    "3527": "DOWNTOWNER PASSPORT",
    "3528": "RED LION INNS",
    "3529": "CP (CANADIAN PACIFIC) HOTELS",
    "3530": "RENAISSANCE HOTELS",
    "3531": "KAUAI COCONUT BEACH RESORT",
    "3532": "ROYAL KONA RESORT",
    "3533": "HOTEL IBIS",
    "3534": "SOUTHERN PACIFIC HOTEL",
    "3535": "HILTON INTERNATIONAL",
    "3536": "AMFAC HOTELS",
    "3537": "ANA HOTELS",
    "3538": "CONCORDE HOTELS",
    "3539": "SUMMERFIELD SUITES HOTEL",
    "3540": "IBEROTEL GITEKS",
    "3541": "HOTEL OKURA",
    "3542": "ROYAL HOTELS",
    "3543": "FOUR SEASONS HOTELS",
    "3544": "CIGA HOTELS",
    "3545": "SHANGRI LA INTERNATIONAL",
    "3546": "SIERRA SUITES HOTELS",
    "3547": "BREAKERS RESORT",
    "3548": "HOTELS MELIA",
    "3549": "AUBERGE DES GOVERNEURES",
    "3550": "REGAL 8 INNS",
    "3551": "MIRAGE HOTEL AND CASINO",
    "3552": "COAST HOTEL",
    "3553": "PARKS INNS INTERNATIONAL",
    "3554": "PINEHURST RESORT",
    "3555": "TREASURE ISLAND HOTEL AND CASINO",
    "3556": "BARTON CREEK RESORT",
    "3557": "MANHATTAN EAST SUITE HOTELS",
    "3558": "JOLLY HOTELS",
    "3559": "CANDLEWOOD SUITES",
    "3560": "ALADDIN RESORT AND CASINO",
    "3561": "GOLDEN NUGGET",
    "3562": "COMFORT INNS",
    "3563": "JOURNEY'S END MOTELS",
    "3564": "SAM'S TOWN HOTEL AND CASINO",
    "3565": "RELAX INNS",
    "3566": "GARDEN PALACE HOTEL",
    "3567": "SOHO GRAND HOTEL",
    "3568": "LADBROKE HOTELS",
    "3569": "TRIBECA GRAND HOTEL",
    "3570": "FORUM HOTELS",
    "3571": "GRAND WAILEA RESORT",
    "3572": "MIYAKO HOTEL",
    "3573": "SANDMAN HOTELS",
    "3574": "VENTURE INN",
    "3575": "VAGABOND HOTELS",
    "3576": "LA QUINTA RESORT",
    "3577": "MANDARIN ORIENTAL HOTELS",
    "3578": "FRANKENMUTH BAVARIAN",
    "3579": "HOTEL MERCURE",
    "3580": "HOTEL DEL CORONADO",
    "3581": "DELTA HOTELS",
    "3582": "CALIFORNIA HOTEL AND CASINO",
    "3583": "SAS HOTELS",
    "3584": "PRINCESS HOTELS INTERNATIONAL",
    "3585": "HUNGAR HOTELS",
    "3586": "SOKOS HOTEL",
    "3587": "DORAL HOTELS",
    "3588": "HELMSLEY HOTELS",
    "3589": "DORAL GOLF RESORT",
    "3590": "FAIRMONT HOTELS",
    "3591": "SONESTA HOTELS",
    "3592": "OMNI HOTELS",
    "3593": "CUNARD HOTELS",
    "3594": "ARIZONA BILTMORE",
    "3595": "HOSPITALITY INNS",
    "3596": "WYNN LAS VEGAS",
    "3597": "RIVERSIDE RESORT AND CASINO",
    "3598": "REGENT INTERNATIONAL  HOTEL",
    "3599": "PANNONIA HOTELS",
    "3600": "SADDLEBROOK RESORT   TAMPA",
    "3601": "TRADEWINDS RESORTS",
    "3602": "HUDSON HOTEL",
    "3603": "NOAH'S HOTEL",
    "3604": "HILTON GARDEN INN",
    "3605": "JURYS DYLE HOTEL GROUP",
    "3606": "JEFFERSON HOTEL",
    "3607": "FONTAINEBLEAU RESORT",
    "3608": "GAYLORD OPRYLAND",
    "3609": "GAYLORD PALMS",
    "3610": "GAYLORD TEXAN",
    "3611": "C MON INN",
    "3612": "MOEVENPICK HOTELS",
    "3613": "MICROTEL INN AND SUITES",
    "3614": "AMERICINN",
    "3615": "TRAVELODGE",
    "3616": "HERMITAGE HOTEL",
    "3617": "AMERICA'S BEST VALUE INN",
    "3618": "GREAT WOLF",
    "3619": "ALOFT HOTELS",
    "3620": "BINION'S HORSESHOE CLUB",
    "3621": "EXTENDED STAY",
    "3622": "MERLIN HOTEL GROUP",
    "3623": "DORINT HOTELS",
    "3624": "LADY LUCK HOTEL AND CASINO",
    "3625": "HOTEL UNIVERSALE",
    "3626": "STUDIO PLUS",
    "3627": "EXTENDED STAY AMERICA",
    "3628": "EXCALIBUR HOTEL AND CASINO",
    "3629": "DAN HOTELS",
    "3630": "EXTENDED STAY DELUXE",
    "3631": "SLEEP INNS",
    "3632": "THE PHOENICIAN",
    "3633": "RANK HOTELS",
    "3634": "SWISSOTEL",
    "3635": "RESO HOTEL",
    "3636": "SAROVA HOTELS",
    "3637": "RAMADA INNS",
    "3638": "HOWARD JOHNSON",
    "3639": "MOUNT CHARLOTTE THISTLE",
    "3640": "HYATT HOTELS",
    "3641": "SOFITEL HOTELS",
    "3642": "NOVOTEL HOTELS",
    "3643": "STEIGENBERGER HOTELS",
    "3644": "ECONOLODGES",
    "3645": "QUEENS MOAT HOUSES",
    "3646": "SWALLOW HOTELS",
    "3647": "HUSA HOTELS",
    "3648": "DE VERA HOTELS",
    "3649": "RADISSON HOTELS",
    "3650": "RED ROOF INNS",
    "3651": "IMPERIAL LONDON HOTELS",
    "3652": "EMBASSY HOTELS",
    "3653": "PENTA HOTELS",
    "3654": "LOEWS HOTELS",
    "3655": "SCANDIC HOTELS",
    "3656": "SARA HOTELS",
    "3657": "OBEROI HOTELS",
    "3658": "NEW OTANI HOTELS",
    "3659": "TAJ HOTELS INTERNATIONAL",
    "3660": "KNIGHTS INN",
    "3661": "METROPOLE HOTELS",
    "3662": "CIRCUS CIRCUS HOTEL AND CASINO",
    "3663": "HOTELES EL PRESIDENTE",
    "3664": "FLAG INNS",
    "3665": "HAMPTON INN HOTELS",
    "3666": "STAKIS HOTELS",
    "3667": "LUXOR HOTEL AND CASINO",
    "3668": "MARITIM HOTELS",
    "3669": "EL DORADO HOTEL AND CASINO",
    "3670": "ARCADE HOTELS",
    "3671": "ARCTIA HOTELS",
    "3672": "CAMPANILE HOTELS",
    "3673": "IBUSZ HOTELS",
    "3674": "RANTASIPI HOTELS",
    "3675": "INTERHOTEL CEDOK",
    "3676": "MONTE CARLO HOTEL AND CASINO",
    "3677": "CLIMAT DE FRANCE HOTELS",
    "3678": "CUMULUS HOTELS",
    "3679": "SILVER LEGACY HOTEL AND CASINO",
    "3680": "HOTEIS OTHAN",
    "3681": "ADAMS MARK HOTELS",
    "3682": "SAHARA HOTEL AND CASINO",
    "3683": "BRADBURY SUITES",
    "3684": "BUDGET HOSTS INNS",
    "3685": "BUDGETEL INNS",
    "3686": "SUSSE CHALET",
    "3687": "CLARION HOTELS",
    "3688": "COMPRI HOTELS",
    "3689": "CONSORT HOTELS",
    "3690": "COURTYARD BY MARRIOTT",
    "3691": "DILLON INN",
    "3692": "DOUBLETREE HOTELS",
    "3693": "DRURY INN",
    "3694": "ECONOMY INNS OF AMERICA",
    "3695": "EMBASSY SUITES",
    "3696": "EXCEL INN",
    "3697": "FAIRFIELD HOTELS",
    "3698": "HARLEY HOTELS",
    "3699": "MIDWAY MOTOR LODGE",
    "3700": "MOTEL 6",
    "3701": "LA MANSION DEL RICO",
    "3702": "REGISTRY HOTELS",
    "3703": "RESIDENCE INN",
    "3704": "ROYCE HOTELS",
    "3705": "SANDMAN INN",
    "3706": "SHILO INN",
    "3707": "SHONEY'S INN",
    "3708": "VIRGIN RIVER HOTEL AND CASINO",
    "3709": "SUPER 8 MOTELS",
    "3710": "THE RITZ CARLTON",
    "3711": "FLAG INNS (AUSTRALIA)",
    "3712": "BUFFALO BILL'S HOTEL AND CASINO",
    "3713": "QUALITY PACIFIC HOTEL",
    "3714": "FOUR SEASONS (AUSTRALIA) HOTELS",
    "3715": "FAIRFIELD INN",
    "3716": "CARLTON HOTELS",
    "3717": "CITY LODGE HOTELS",
    "3718": "KAROS HOTELS",
    "3719": "PROTEA HOTELS",
    "3720": "SOUTHERN SUN HOTELS",
    "3721": "CONRAD HOTELS",
    "3722": "WYNDHAM",
    "3723": "RICA HOTELS",
    "3724": "INTER NOR HOTELS",
    "3725": "SEA PINES RESORT",
    "3726": "RIO SUITES",
    "3727": "BROADMOOR HOTEL",
    "3728": "BALLYS HOTEL AND CASINO",
    "3729": "JOHN ASCUAGAS NUGGET",
    "3730": "MGM GRAND HOTEL",
    "3731": "HARRAHS HOTELS AND CASINOS",
    "3732": "OPRYLAND HOTEL",
    "3733": "BOCA RATON RESORT",
    "3734": "HARVEY BRISTOL HOTELS",
    "3735": "MASTERS ECONOMY INNS",
    "3736": "COLORADO BELLE EDGEWATER RESORT",
    "3737": "RIVIERA HOTEL AND CASINO",
    "3738": "TROPICANA RESORT AND CASINO",
    "3739": "WOODSIDE HOTELS AND RESORTS",
    "3740": "TOWNEPLACE SUITES",
    "3741": "MILLENNIUM HOTELS",
    "3742": "CLUB MED",
    "3743": "BILTMORE HOTEL AND SUITES",
    "3744": "CAREFREE RESORTS",
    "3745": "ST. REGIS HOTEL",
    "3746": "ELIOT HOTELS",
    "3747": "CLUB CORP/CLUB RESORTS",
    "3748": "WELLESLEY INNS",
    "3749": "BEVERLY HILLS HOTEL",
    "3750": "CROWNE PLAZA HOTELS",
    "3751": "HOMEWOOD SUITES",
    "3752": "PEABODY HOTELS",
    "3753": "GREENBRIAR RESORTS",
    "3754": "AMELIA ISLAND PLANTATION",
    "3755": "HOMESTEAD",
    "3756": "SOUTH SEAS RESORTS",
    "3757": "CANYON RANCH",
    "3758": "KAHALA MANDARIN ORIENTAL HOTEL",
    "3759": "ORCHID AT MAUNA LAI",
    "3760": "HALEKULANI HOTEL/WAIKIKI PARC",
    "3761": "PRIMADONNA HOTEL AND CASINO",
    "3762": "WHISKEY PETE'S HOTEL AND CASINO",
    "3763": "CHATEAU ELAN WINERY AND RESORT",
    "3764": "BEAU RIVAGE HOTEL AND CASINO",
    "3765": "BELLAGIO HOTEL AND CASINO",
    "3766": "FREMONT HOTEL AND CASINO",
    "3767": "MAIN STREET HOTEL AND CASINO",
    "3768": "SILVER STAR HOTEL AND CASINO",
    "3769": "STRATOSPHERE HOTEL AND CASINO",
    "3770": "SPRINGHILL SUITES",
    "3771": "CAESARS HOTEL AND CASINO",
    "3772": "NEMACOLIN WOODLANDS",
    "3773": "VENETIAN RESORT HOTEL AND CASINO",
    "3774": "NEW YORK, NEW YORK HOTEL AND CASINO",
    "3775": "SANDS RESORT",
    "3776": "NEVELE GRANDE RESORT AND COUNTRY CLUB",
    "3777": "MANDALAY BAY RESORT",
    "3778": "FOUR POINTS HOTELS",
    "3779": "W HOTELS",
    "3780": "DISNEY RESORTS",
    "3781": "PATRICIA GRAND RESORT HOTELS",
    "3782": "ROSEN HOTELS & RESORTS",
    "3783": "TOWN AND COUNTRY RESORT & CONVENTION CENTER",
    "3784": "FIRST HOSPITALITY HOTELS",
    "3785": "OUTRIGGER HOTELS AND RESORTS",
    "3786": "OHANA HOTELS OF HAWAII",
    "3787": "CARIBE ROYALE RESORT SUITES & VILLAS",
    "3788": "ALA MOANA HOTEL",
    "3789": "SMUGGLERS' NOTCH RESORT",
    "3790": "RAFFLES HOTELS",
    "3791": "STAYBRIDGE SUITES",
    "3792": "CLARIDGE CASINO HOTEL",
    "3793": "THE FLAMINGO HOTELS",
    "3794": "GRAND CASINO HOTELS",
    "3795": "PARIS LAS VEGAS HOTEL",
    "3796": "PEPPERMILL HOTEL CASINO",
    "3797": "ATLANTIC CITY HILTON",
    "3798": "EMBASSY VACATION RESORT",
    "3799": "HALE KOA HOTEL",
    "3800": "HOMESTEAD SUITES",
    "3801": "WILDERNESS HOTEL AND GOLF RESORT",
    "3802": "THE PALACE HOTEL",
    "3803": "THE WIGWAM GOLF RESORT AND SPA",
    "3804": "THE DIPLOMAT COUNTRY CLUB AND SPA",
    "3805": "THE ATLANTIC",
    "3806": "PRINCEVILLE RESORT",
    "3807": "ELEMENT",
    "3808": "LXR",
    "3809": "SETTLE INN",
    "3810": "LA COSTA RESORT",
    "3811": "PREMIER INN",
    "3812": "HYATT PLACE",
    "3813": "HOTEL INDIGO",
    "3814": "THE ROOSEVELT HOTEL NY",
    "3815": "HOLIDAY INN NICKELODEON",
    "3816": "HOME2 SUITES BY HILTON",
    "3817": "AFFINIA",
    "3818": "MAINSTAY SUITES",
    "3819": "OXFORD SUITES",
    "3820": "JUMEIRAH ESSEX HOUSE",
    "3821": "CARIBE ROYALE",
    "3822": "CROSSLAND",
    "3823": "GRAND SIERRA RESORT",
    "3824": "ARIA",
    "3825": "Vdara (Vdara Hotel and Spa)",
    "3826": "AUTOGRAPH",
    "3827": "GALT HOUSE",
    "3828": "COSMOPOLITAN OF LAS VEGAS",
    "3829": "Country Inn by Carlson",
    "3830": "Park Plaza Hotel",
    "3831": "Waldorf",
    "3832": "CURIO HOTELS",
    "3833": "CANOPY BY HILTON",
    "3834": "BAYMONT INN",
    "3835": "DOLCE HOTELS AND RESORTS",
    "3836": "HAWTHORNE SUITES BY WYNDHAM",
    "3874": "FIRST HOSPITALITY HOTELS",
    "3999": "Lodging\u2014Hotels, Motels, Resorts",
    "4011": "RAILROADS   FREIGHT",
    "4012": "RAILROADS   RENFE",
    "4013": "GRUPO ACCOR / WAGONS LITS",
    "4014": "ADIF",
    "4111": "TRANSPRTN SUBRBN & LOCAL COMTR PSNGR, INCL FERRIES",
    "4112": "PASSENGER RAILWAYS",
    "4119": "AMBULANCE SERVICES",
    "4121": "LIMOUSINES AND TAXICABS",
    "4131": "BUS LINES",
    "4132": "TRANSPORTATION SERVICES. SALES ON BOARD (CRUISE)",
    "4133": "LOCAL TRANSPORTATION (EXCEPT SUBWAY)",
    "4214": "FREIGHT CARRIER,TRUCKING LCL/LNG DIST, MVG/STORAGE",
    "4215": "COURIER SVC AIR & GROUND, FREIGHT FORWARDERS",
    "4225": "PUBLIC WAREHOUSING FARM, REFRIG GOODS, HHG STORAGE",
    "4411": "CRUISE LINES",
    "4457": "BOAT LEASES AND BOAT RENTALS",
    "4468": "MARINAS, MARINE SERVICE/SUPPLIES",
    "4511": "AIR CARRIERS, AIRLINES NOT ELSEWHERE CLASSIFIED",
    "4582": "AIRPORTS, AIRPORT TERMINALS, FLYING FIELDS",
    "4722": "TRAVEL AGENCIES AND TOUR OPERATORS",
    "4761": "TELEMARKETING: TRAVEL RELATED SERVICES, VITAMINS",
    "4783": "TOLL AND BRIDGE FEES   ACESA",
    "4784": "BRIDGE AND ROAD FEES, TOLLS",
    "4785": "MOTORWAY (MANUAL TICKETS)",
    "4786": "ACESA",
    "4789": "TRANSPORTATION SERVICES NOT ELSEWHERE CLASSIFIED",
    "4811": "TELEFONICA: SERVICES",
    "4812": "TELECOMMUNICATION EQUIPMENT INCL TELEPHONE SALES",
    "4813": "KEYENTRY TELE MERCNT LCL/LNG DIST. NON FACE TOFACE",
    "4814": "TELECOM INCL PREPAID/RECURRING PHONE SVCS",
    "4815": "TELEFONICA: EQUIPMENT SALES",
    "4816": "COMPUTER NETWORK/INFORMATION SERVICES",
    "4817": "MOVISTAR: EQUIPMENT SALES",
    "4818": "VODAFONE: EQUIPMENT SALES",
    "4819": "AMENA: EQUIPMENT SALES",
    "4821": "TELEGRAPH SERVICES",
    "4829": "MONEY TRANSFER MERCHANT",
    "4899": "CABLE, SATELLITE, OTHER PAY TELEVISION, RADIO SVCS",
    "4900": "UTLTS ELCTRC, GAS, HEATING OIL, SANITARY, WATER",
    "5013": "MOTOR VEHICLE SUPPLIES AND NEW PARTS",
    "5021": "OFFICE AND COMMERCIAL FURNITURE",
    "5039": "CONSTRUCTION MATERIALS NOT ELSEWHERE CLASSIFIED",
    "5044": "OFFICE PHOTOGRAPHIC PHOTOCOPY & MICROFILM EQUIPMT.",
    "5045": "COMPUTERS, COMPUTER PERIPHERAL EQUIPMENT, SOFTWARE",
    "5046": "COMMERCIAL EQUIPMENT, NOT ELSEWHERE CLASSIFIED",
    "5047": "DENTAL/LAB/MED/OPHTHALMIC HOSP EQUIP & SUPPLIES",
    "5051": "METAL SERVICE CENTERS AND OFFICES",
    "5065": "ELECTRICAL PARTS AND EQUIPMENT",
    "5072": "HARDWARE EQUIPMENT AND SUPPLIES",
    "5074": "PLUMBING AND HEATING EQUIPMENT",
    "5085": "INDUSTRIAL SUPPLIES NOT ELSEWHERE CLASSIFIED",
    "5094": "PRECIOUS STONES AND METALS, WATCHES AND JEWELRY",
    "5099": "DURABLE GOODS, NOT ELSEWHERE CLASSIFIED",
    "5111": "STATIONERY/OFFICE SUPPLIES/PRINTING & WRITING PAP.",
    "5122": "DRUGS, DRUP PROPRIETARIES, AND DRUGGIST'S SUPPLIES",
    "5131": "PIECE GOODS,NOTIONS,AND OTHER DRY GOODS",
    "5137": "MEN'S/WOMEN'S/CHILDREN'S UNIFORMS/COMMERCIAL CLOTH",
    "5139": "COMMERCIAL FOOTWEAR",
    "5169": "CHEMICALS/ALLIED PRODUCTS NOT ELSEWHERE CLASSIFIED",
    "5172": "PETROLEUM AND PETROLEUM PRODUCTS",
    "5192": "BOOKS,PERIODICALS AND NEWSPAPERS",
    "5193": "FLORIST SUPPLIES,NURSERY STOCK & FLOWERS",
    "5198": "PAINTS,VARNISHES AND SUPPLIES",
    "5199": "NONDURABLE GOODS (NOT ELSEWHERE CLASSIFIED)",
    "5200": "HOME SUPPLY WAREHOUSE STORES",
    "5211": "BUILDING MATERIALS, LUMBER STORES",
    "5231": "GLASS, PAINT, WALLPAPER STORES",
    "5251": "HARDWARE STORES",
    "5261": "LAWN AND GARDEN SUPPLY STORES",
    "5271": "MOBILE HOME DEALERS",
    "5300": "WHOLESALE CLUBS",
    "5309": "DUTY FREE STORES",
    "5310": "DISCOUNT STORES",
    "5311": "DEPARTMENT STORES",
    "5312": "TIER 1 RETAIL   MDS",
    "5313": "DEPARTMENT STORES OF HOBBY, TOYS AND GAMES",
    "5314": "DEPARTMENT STORES (AKI BRICOBI)",
    "5331": "VARIETY STORES",
    "5333": "HYPERMARKETS OF FOOD",
    "5335": "GRUPO ALCAMPO",
    "5338": "HIPERCOR",
    "5350": "DOOR TO DOOR SALES",
    "5399": "MISCELLANEOUS GENERAL MERCHANDISE",
    "5411": "GROCERY STORES, SUPERMARKETS",
    "5421": "Retail outlets",
    "5422": "FREEZER, LOCKER MEAT PROVISIONERS",
    "5441": "CANDY, NUT, CONFECTIONERY STORES",
    "5451": "DAIRY PRODUCTS STORES",
    "5462": "BAKERIES",
    "5499": "MISC FOOD STORE CONVENIENCE,MRKT,SPLTY,VENDNG MACS",
    "5511": "AUTO & TRUCK DLRS SALES,SVC, REPRS,PRTS, & LEASING",
    "5521": "AUTOMOBILE AND TRUCK DEALERS (USED ONLY) SALES",
    "5531": "AUTO STORE, HOME SUPPLY STORES",
    "5532": "AUTOMOTIVE TIRE STORES",
    "5533": "AUTOMOTIVE PARTS, ACCESSORIES STORES",
    "5541": "SERVICE STATIONS WITH OR WITHOUT ANCILLARY SERVICE",
    "5542": "FUEL DISPENSER, AUTOMATED",
    "5543": "SERVICE STATIONS (CAMPSA)",
    "5544": "TIER 2 CONVENIENCE   MDS",
    "5545": "HOME DELIVERY",
    "5551": "BOAT DEALERS",
    "5561": "CAMPER DEALERS, RECREATIONAL AND UTILITY TRAILERS",
    "5571": "MOTORCYCLE SHOPS AND DEALERS",
    "5592": "MOTOR HOME DEALERS",
    "5598": "SNOWMOBILE DEALERS",
    "5599": "MISC/AUTO/AIRCRAFT/FARM EQUIP  NOT ELSEWHERE CLASS",
    "5611": "MEN'S AND BOY'S CLOTHING AND ACCESSORIES STORES",
    "5621": "WOMEN'S READY TO WEAR STORES",
    "5631": "WOMEN'S ACCESSORY AND SPECIALTY STORES",
    "5641": "CHILDREN'S AND INFANT'S WEAR STORES",
    "5651": "FAMILY CLOTHING STORES",
    "5655": "SPORTS APPAREL, RIDING APPAREL STORES",
    "5661": "SHOE STORES",
    "5662": "TIER 1 SUPERMARKET   MDS",
    "5663": "TIER 2 SUPERMARKET MDS",
    "5681": "FURRIERS AND FUR SHOPS",
    "5691": "MEN'S AND WOMEN'S CLOTHING STORES",
    "5697": "ALTERATIONS, MENDING, SEAMSTRESSES, TAILORS",
    "5698": "WIG AND TOUPEE SHOPS",
    "5699": "ACCESSORY AND APPAREL STORES MISCELLANEOUS",
    "5712": "EQUIP, FURNITURE, HOME FURNSHNGS STRS (EXCPT APPL)",
    "5713": "FLOOR COVERING STORES",
    "5714": "DRAPERY, UPOLSTERY, AND WINDOW COVERINGS STORES",
    "5718": "FIREPLACE, FIREPLACE SCREENS & ACCESSORIES STORES",
    "5719": "MISCELLANEOUS HOUSE FURNISHING SPECIALTY SHOPS",
    "5722": "HOUSEHOLD APPLIANCE STORES",
    "5732": "ELECTRONIC SALES",
    "5733": "MUSIC STORES INSTRUMENTS, PIANOS, SHEET MUSIC",
    "5734": "COMPUTER SOFTWARE STORES",
    "5735": "RECORD SHOPS",
    "5811": "CATERERS",
    "5812": "EATING PLACES, RESTAURANTS",
    "5813": "BAR,LOUNGE,DISCO,NIGHTCLUB,TAVERN ALCOHOLIC DRINKS",
    "5814": "FAST FOOD RESTAURANTS",
    "5815": "Digital Goods   Audiovisual Media Including Books, Movies, and Music",
    "5816": "DIGITAL GOODS \u2013 GAMES",
    "5817": "DIGITAL GOODS \u2013 Software Applications",
    "5818": "Merchants that sell at least two of the following digital products   MCC_CD 5815, 5816, 5817",
    "5911": "COSMETIC AND CLEANING STORES",
    "5912": "DRUG STORES, PHARMACIES",
    "5913": "HERBALISTS AND OTHER PHARMACIES",
    "5921": "PACKAGE STORES, BEER, WINE, LIQUOR",
    "5931": "SECOND HAND STORES, USED MERCHANDISE STORES",
    "5932": "ANTIQUE SHOPS SALES,REPAIRS,RESTORATION SERVICES",
    "5933": "PAWN SHOPS",
    "5935": "SALVAGE AND WRECKING YARDS",
    "5936": "LOW VALUE   MISCELLANEOUS (CHACHARAS)",
    "5937": "ANTIQUE REPRODUCTION STORES",
    "5939": "TOYS \"R\" US",
    "5940": "BICYCLE SHOPS SALES AND SERVICE",
    "5941": "SPORTING GOODS STORES",
    "5942": "BOOK STORES",
    "5943": "OFFICE, SCHOOL SUPPLY, AND STATIONERY STORES",
    "5944": "CLOCK, JEWELRY, WATCH, AND SILVERWARE STORE",
    "5945": "GAME, TOY, AND HOBBY SHOPS",
    "5946": "CAMERA AND PHOTOGRAPHIC SUPPLY STORES",
    "5947": "GIFT, CARD, NOVELTY AND SOUVENIR SHOPS",
    "5948": "LEATHER GOODS AND LUGGAGE STORES",
    "5949": "FABRIC, NEEDLEWORK, PIECE GOODS, AND SEWING STORES",
    "5950": "CRYSTAL AND GLASSWARE STORES",
    "5951": "BAZARES MAYA",
    "5952": "FAMILY CLOTHING STORE (CORTEFIEL)",
    "5953": "LOUIS VUITTON/ LOEWE",
    "5955": "FAMILY CLOTHING STORE (PRENATAL)",
    "5956": "DEPARTMENT STORES (VIPS)",
    "5957": "FAMILY CLOTHING STORE (C & A)",
    "5958": "CAMERA AND PHOTOGRAPHIC SUPPLY STORES (GENERAL OPT",
    "5959": "DEPARTMENT STORES (EL CORTE ING)",
    "5960": "DIRECT MARKETING INSURANCE SERVICES",
    "5961": "DIRECT MARKETING. CATALOG AND RETAIL MERCHANTS",
    "5962": "DIRECT MARKETING TRAVEL RELATED ARRANGEMENT SERVS.",
    "5963": "DOOR TO DOOR SALES",
    "5964": "DIRECT MARKETING CATALOG MERCHANTS",
    "5965": "DIRECT MARKETING COMBINATION CATALOG/RETAIL MERCH.",
    "5966": "DIRECT MARKETING OUTBOUND TELEMARKETING MERCHANTS",
    "5967": "DIRECT MARKETING INBOUND TELEMARKETING MERCHANTS",
    "5968": "DIRECT MARKETING CONTINUITY/SUBSCRIPTION MERCHANTS",
    "5969": "DIRECT MARKETING OTHER DIRECT MARKETERS/NOT ELSEW.",
    "5970": "ARTIST SUPPLY STORES, CRAFT SHOPS",
    "5971": "ART DEALERS AND GALLERIES",
    "5972": "STAMP & COIN STORES PHILATELIC & NUMISMATIC SUPPLY",
    "5973": "RELIGIOUS GOODS STORES",
    "5974": "RUBBER STAMP STORES",
    "5975": "HEARING AIDS SALES, SERVICE, SUPPLY STORES",
    "5976": "ORTHOPEDIC GOODS ARTIFICIAL LIMB STORES",
    "5977": "COSMETIC STORES",
    "5978": "TYPEWRITER STORES RENTALS, SALES, SERVICE",
    "5983": "FUEL DEALERS COAL, FUEL OIL, LIQ PETROLEUM, WOOD",
    "5991": "WHOLE SALES EXCEPT FOOD",
    "5992": "FLORISTS",
    "5993": "CIGAR STORES AND STANDS",
    "5994": "NEWS DEALERS AND NEWSSTANDS",
    "5995": "PET SHOPS   PET FOODS AND SUPPLIES",
    "5996": "SWIMMING POOLS   SALES AND SUPPLIES",
    "5997": "ELECTRIC RAZOR STORES   SALES AND SERVICE",
    "5998": "TENT AND AWNING SHOPS",
    "5999": "MISCELLANEOUS AND SPECIALTY RETAIL STORES",
    "6010": "MEMBER MANUAL CASH DISBURSEMENT",
    "6011": "MEMBER AUTOMATED CASH DISBURSEMENT",
    "6012": "MEMBER MERCHANDISE AND SERVICES",
    "6022": "FINANCIAL INSTITUTION (RCL INTERNAL)",
    "6023": "STATE BANKS (RCL INTERNAL)",
    "6025": "NATIONAL BANKS (RCL INTERNAL)",
    "6026": "NATIONAL BANKS NON FEDERAL (RCL INTERNAL)",
    "6028": "UNICORPORATED PRIVATE BANKS (RCL INTERNAL)",
    "6050": "QUASI CASH   MEMBER",
    "6051": "QUASI CASH MERCHANT",
    "6211": "SECURITIES BROKERS/DEALERS",
    "6300": "INSURANCE SALES,UNDERWRITING,AND PREMIUMS",
    "6310": "INSURANCE SALES",
    "6381": "INSURANCE PREMIUMS",
    "6399": "INSURANCE CARRIERS NOT ELSEWHERE CLASSIFIED",
    "6513": "REAL ESTATE AGENTS AND MANAGERS RENTALS",
    "6529": "REMOTE STORED VALUE LOAD   MEMBER",
    "6530": "REMOTE STORED VALUE LOAD   MERCHANT",
    "6531": "PAYMNT SVC PROVIDER PAYMNT TRANSFER FOR A PURCHASE",
    "6532": "PYMT SVC PROVIDR MBR FINANCL INSTITUTN PYMT TRANS",
    "6533": "PSP MERCHANT PAYMENT TRANSACTION",
    "6534": "MONEY TRANSFER MEMBER",
    "6535": "VALUE PURCHASE MEMBER FINANCIAL INSTITUTIONS",
    "6536": "MONEYSEND   INTRACOUNTRY",
    "6537": "MONEYSEND   INTERCOUNTRY",
    "6538": "MONEYSEND FUNDING",
    "6539": "FUNDING (EXCLUDING MONEYSEND)",
    "6540": "POI FUNDING TRANSACTIONS EXCLUDING MASTERCARD MONEYSEND",
    "6541": "INJURY/CASUALTY",
    "6542": "LIFE/INJURY/CASUALTY INSURANCE AGENCY",
    "6543": "MUTUAL AID ENTERPRISE",
    "6555": "MASTERCARD INITIATED REBATE/REWARD",
    "6611": "OVERPAYMENTS",
    "6760": "SAVINGS BONDS",
    "7010": "HOTEL/INNS(REGULAR)",
    "7011": "LODGING HOTELS,MOTELS,RESORTS NOT CLASSIFIED",
    "7012": "TIMESHARES",
    "7013": "HOTELS AND MOTELS",
    "7014": "HOTELS AND MOTELS (NH HOTELES)",
    "7015": "TIMESHARES",
    "7032": "RECREATIONAL AND SPORTING CAMPS",
    "7033": "CAMPGROUNDS AND TRAILER PARKS",
    "7210": "CLEANING, GARMENT, AND LAUNDRY SERVICES",
    "7211": "LAUNDRY SERVICES   FAMILY AND COMMERICAL",
    "7216": "DRY CLEANERS",
    "7217": "CARPET AND UPHOLSTERY CLEANING",
    "7221": "PHOTOGRAPHIC STUDIOS",
    "7230": "BARBER AND BEAUTY SHOPS",
    "7231": "BEAUTY, BARBER SHOP AND GYMS",
    "7232": "MASSAGE PARLOURS",
    "7251": "HAT CLEANING SHOPS, SHOE REPAIR SHOPS, SHOE SHINE",
    "7261": "FUNERAL SERVICE AND CREMATORIES",
    "7273": "DATING AND ESCORT SERVICES",
    "7276": "TAX PREPARATION SERVICE",
    "7277": "DEBT, MARRIAGE, PERSONAL COUNSELING SERVICE",
    "7278": "BUYING/SHOPPING CLUBS, SERVICES",
    "7280": "HOSPITAL PATIENT PERSONAL FUNDS WITHDRAWAL ACCTS",
    "7295": "BABY SITTING SERVICES",
    "7296": "CLOTHING RENTAL COSTUMES,UNIFORMS,FORMAL WEAR",
    "7297": "MASSAGE PARLORS",
    "7298": "HEALTH  AND BEAUTY SPAS",
    "7299": "OTHER SERVICES (NOT ELSEWHERE CLASSIFIED)",
    "7311": "ADVERTISING SERVICES",
    "7321": "CONSUMER CREDIT REPORTING AGENCIES",
    "7332": "BLUEPRINTING AND PHOTOCOPYING SERVICES",
    "7333": "COMMERCIAL ART, GRAPHICS, PHOTOGRAPHY",
    "7338": "QUICK COPY,REPRODUCTION AND BLUEPRINTING SERVICES",
    "7339": "STENOGRAPHIC AND SECRETARIAL SUPPORT SERVICES",
    "7341": "WINDOW CLEANING SERVICES",
    "7342": "EXTERMINATING AND DISINFECTING SERVICES",
    "7349": "CLEANING AND MAINTENANCE, JANITORIAL SERVICES",
    "7361": "EMPLOYMENT AGENCIES, TEMPORARY HELP SERVICES",
    "7372": "COMP PROGRAMING,DATA PRCSNG,INTGRTD SYS DSGN SRVS",
    "7375": "INFORMATION RETRIEVAL SERVICES",
    "7379": "COMPUTER MAIN./REPAIR/SERVICES NOT ELSEWHERE CLASS",
    "7392": "CONSULTING, MANAGEMENT, AND PUBLIC RELATIONS SVCS",
    "7393": "DETECTVE/PROTECTVE AGNCY,SECURITY SRVS, ARMOR CARS",
    "7394": "EQUIPMENT RENTAL&LEASING SVS, FURNTURE/TOOL RENTAL",
    "7395": "PHOTO DEVELOPING, PHOTOFINISHING LABORATORIES",
    "7399": "BUSINESS SERVICES NOT ELSEWHERE CLASSIFIED",
    "7511": "TRUCK STOP TRANSACTIONS",
    "7512": "AUTOMOBILE RENTAL AGENCY NOT ELSEWHERE CLASSIFIED",
    "7513": "TRUCK RENTAL",
    "7519": "MOTOR HOME AND RECREATIONAL VEHICLE RENTAL",
    "7523": "AUTOMOBILE PARKING LOTS AND GARAGES",
    "7524": "EXPRESS PAYMENT SERVICES",
    "7531": "AUTOMOTIVE BODY REPAIR SHOPS",
    "7534": "TIRE RETREADING AND REPAIR SHOPS",
    "7535": "AUTOMOTIVE PAINT SHOPS",
    "7538": "AUTOMOTIVE SERVICE SHOPS",
    "7539": "AUTOMOTIVE SERVICE SHOPS",
    "7542": "CAR WASHES",
    "7549": "TOWING SERVICES",
    "7622": "ELECTRONIC REPAIR SHOPS",
    "7623": "AIR CONDITIONING AND REFRIGERATION REPAIR SHOPS",
    "7629": "ELECTRICAL AND SMALL APPLIANCE REPAIR SHOPS",
    "7631": "CLOCK, JEWELRY, AND WATCH REPAIR SHOPS",
    "7641": "FURNITURE REUPHOLSTERY AND REPAIR, REFINISHING",
    "7692": "WELDING REPAIR",
    "7699": "MISCELLANEOUS REPAIR SHOPS AND RELATED SERVICES",
    "7800": "Government Owned Lotteries",
    "7801": "Internet Gambling",
    "7802": "Government Licensed Horse/Dog Racing",
    "7829": "MOTION PICTURE/VIDEO TAPE PRODUCTION/DISTRIBUTION",
    "7832": "MOTION PICTURE THEATERS",
    "7833": "MOTION PICTURE THEATERS (QUICK PAYMENT SERVICE)",
    "7841": "VIDEO ENTERTAINMENT RENTAL STORES",
    "7911": "DANCE HALLS, SCHOOLS, AND STUDIOS",
    "7922": "THEATRICAL PRODUCERS(EXCL MOTION PIX),TICKET AGNCY",
    "7929": "BANDS, ORCHESTRAS, & MISC ENTRTNRS NOT ELSWHR CLAS",
    "7932": "POOL AND BILLIARD ESTABLISHMENTS",
    "7933": "BOWLING ALLEYS",
    "7941": "ATHLTIC FIELDS,COMMRCL SPRT,SPRT CLBS,SPRT PROMOTR",
    "7987": "CASINO DE MADRID",
    "7988": "CASINO GAMING CHIPS",
    "7989": "CASINO GAMING CHIPS (CASINOS E CATALUZA)",
    "7990": "ONLAE: NATIONAL LOTTERY",
    "7991": "TOURIST ATTRACTIONS AND EXHIBITS",
    "7992": "GOLF COURSES PUBLIC",
    "7993": "VIDEO AMUSEMENT GAME SUPPLIES",
    "7994": "VIDEO GAME ARCADES/ESTABLISHMENTS",
    "7995": "GAMBLING TRANSACTIONS",
    "7996": "AMUSEMENT PARKS,CARNIVALS,CIRCUS,FORTUNE TELLERS",
    "7997": "CLUBS CNTRY,MBRSHIP(ATHLET,REC,SPRTS,PRIVATE GOLF",
    "7998": "AQUARIUMS, DOLPHINARIUMS, AND SEAQUARIUMS",
    "7999": "RECREATION SERVICES (NOT ELSEWHERE CLASSIFIED)",
    "8011": "DOCTORS, (NOT ELSEWHERE CLASSIFIED)",
    "8021": "DENTISTS, ORTHODONTISTS",
    "8031": "OSTEOPATHIC PHYSICIANS",
    "8041": "CHIROPRACTORS",
    "8042": "OPTOMETRISTS, OPHTHALMOLOGISTS",
    "8043": "OPTICIANS,OPTICAL GOODS & EYEGLASSES",
    "8044": "OPTICAL GOODS AND EYEGLASSES",
    "8049": "CHIROPODISTS, PODIATRISTS",
    "8050": "NURSING AND PERSONAL CARE FACILITIES",
    "8062": "HOSPITALS",
    "8071": "MEDICAL AND DENTAL LABORATORIES",
    "8099": "HEALTH PRACTITIONERS, MEDICAL SRVCS NOT ELSEWHERE",
    "8111": "ATTORNEYS, LEGAL SERVICES",
    "8211": "SCHOOLS, ELEMENTARY AND SECONDARY",
    "8220": "COLLEGES, UNIV, PRO SCHOOLS, JUNIOR COLLEGES",
    "8241": "SCHOOLS, CORRESPONDENCE",
    "8244": "SCHOOLS, BUSINESS AND SECRETARIAL",
    "8249": "SCHOOLS, TRADE AND VOCATIONAL",
    "8299": "SCHOOLS & EDUCATIONAL SVC NOT ELSEWHERE CLASSIFIED",
    "8351": "CHILD CARE SERVICES",
    "8398": "ORGANIZATIONS, CHARITABLE AND SOCIAL SERVICES",
    "8411": "MUSEUMS",
    "8412": "NATIONAL HERITAGE",
    "8641": "ASSOCIATIONS CIVIC, SOCIAL, AND FRATERNAL",
    "8651": "ORGANIZATIONS, POLITICAL",
    "8661": "ORGANIZATIONS, RELIGIOUS",
    "8675": "AUTOMOBILE ASSOCIATIONS",
    "8699": "ORGANIZATIONS, MEMBERSHIP NOT ELSEWHERE CLASSIFIED",
    "8734": "TESTING LABORATORIES (NON MEDICAL)",
    "8911": "ARCHITECTURAL, ENGINEERING, AND SURVEYING SERVICES",
    "8931": "ACCOUNTING, AUDITING AND BOOKKEEPING SERVICES",
    "8999": "PROFESSIONAL SERVICES NOT ELSEWHERE CLASSIFIED",
    "9211": "COURT COSTS INCLUDING ALIMONY AND CHILD SUPPORT",
    "9222": "FINES",
    "9223": "BAIL AND BOND PAYMENTS",
    "9311": "TAX PAYMENTS",
    "9399": "GOVERNMENT SERVICES NOT ELSEWHERE CLASSIFIED",
    "9401": "I PURCHASING PILOT (TEST MCC)",
    "9402": "POSTAL SERVICES GOVERNMENT ONLY",
    "9405": "INTRA GOVERNMENT PURCHASES GOVERNMENT ONLY",
    "9406": "Government owned Lottery Canada Region Only",
    "9411": "GOVERNMENT LOAN PAYMENTS",
    "9702": "GCAS EMERGENCY SERVICES",
    "9751": "UK SUPERMARKETS, ELECTRONIC HOT FILE",
    "9752": "UK PETROLS STATIONS, ELECTRONIC HOT FILE",
    "9753": "GERMANY ACCEPTANCE PROJECTS   DOMESTIC USE ONLY",
    "9754": "Gambling Horse Racing, Dog Racing, Non Sports Intrastate Internet Gambling",
    "9950": "INTRA COMPANY PURCHASES",
    "9999": "NOT ELSEWHERE CLASSIFIED (RCL INTERNAL)"
}